import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';

@Component({
  selector: 'header-lsr',
  standalone: true,
  templateUrl: './header-lsr.html',
  styleUrl: '././header-lsr.css',
  imports: [AngularMaterialModule],
})
export class HeaderLoginSignupResetpw {
  constructor(private router: Router) {}

  goToScoreTable() {
    this.router.navigate(['/score-table']);
  }
}